module.exports = __webpack_public_path__ + "img/cleaning-svg.f6ab3cbe.svg";